import React from "react";
import { RadioGroup, Radio, FormControlLabel } from "@material-ui/core";
import styled from "styled-components";

const Container = styled.div`
& {
  display:flex;
  align-items:center;
  flex-flow: row nowrap;
}
`;
const GridTitle = styled.span`& {
  font-family: Work Sans;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 19px;
  letter-spacing: 0em;  
  }
`;
const Spacer = styled.div`
  flex-grow:1;
`;
const StyledLabel = styled.div`
  font-family: Work Sans;
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 14px;
  /* Text / Dark Gray */
  color: #5F6368;
`;
const TableButtonBar = ({ radioVal, options, handleChange }) => (
  <Container>
    <GridTitle>Grid Pricing</GridTitle>
    <Spacer />
    <RadioGroup
      aria-label="Grid Pricing"
      name={<StyledLabel>{"Grid Pricing"}</StyledLabel>}
      value={radioVal.toString()}
      onChange={handleChange}
      row
    >
      {
        options.map(option => (
          <FormControlLabel
            key={option.value}
            value={option.value.toString()}
            control={<Radio />}
            label={<StyledLabel>{option.name}</StyledLabel>}
          />
        ))
      }
    </RadioGroup>
  </Container>
);

export default TableButtonBar;
